/* eslint-env jquery */
import { liveFaqSearch } from '../pages/faqs.js';
(function ($) {
  const bodyFaq = $('body').hasClass('post-type-archive-faqs');
  $('.search-clear').click(() => {
    $('.search-field').val('');
    if (bodyFaq) {
      liveFaqSearch();
    }
  });
})(jQuery);
